export default __webpack_public_path__ + "static/media/RTR1802V_LateralDer.9debd6bb.webp";